<template>
  <div class="sidebar">
    <div class="fixed">
      <v-layout column align-top justify-center>
        <custom-fab-btn v-if="canAccess(type)" @click-fab="openDialog(type)">{{fabName[type]}}</custom-fab-btn>
        <custom-fab-btn v-if="type === 'BATCH' && canAccess('BATCH_CSV_UPLOAD')" @click-fab="openDialog('BATCH_CSV_UPLOAD')" icon="cloud_upload">CSV Upload</custom-fab-btn>
      </v-layout>

      <v-footer absolute class="footer">
        <v-layout justify-center row wrap>
          <v-flex xs12>
            <user-info @on-change-password="openDialog('CHANGE_PASSWORD')" @on-logout="handleLogout"></user-info>
          </v-flex>
          <v-flex xs12 class="company">Powered by ScanTrust™</v-flex>
        </v-layout>
      </v-footer>

      <v-dialog :width="formWidth[dialog]" :value="dialog" :persistent="true">
        <v-card>
          <component v-if="dialog === 'BATCH'" @on-close-dialog="dialog = false" :is="formComponents['BATCH']"></component>
          <component v-if="dialog === 'FARM'"
            :certificates="this.$route.params && this.$route.params.certificates ? this.$route.params.certificates : []"
            :farm="this.$route.params && this.$route.params.farm ? this.$route.params.farm : {}"
            :farm-id="this.$route.params && this.$route.params.id ? this.$route.params.id : null"
            @on-close-dialog="handleCloseDialog('farms')"
            :is="formComponents['FARM']">
          </component>
          <component v-if="dialog === 'SHIPMENT'"
            :is="formComponents['SHIPMENT']"
            :shipment="this.$route.params && this.$route.params.shipment ? this.$route.params.shipment : {}"
            :shipment-id="this.$route.params && this.$route.params.id ? this.$route.params.id : null"
            @on-close-dialog="handleCloseDialog('shipments')">
          </component>
          <component v-if="dialog === 'LOT'"
            :is="formComponents['LOT']"
            :lot="this.$route.params && this.$route.params.lot ? this.$route.params.lot : {}"
            :shipments="this.$route.params && this.$route.params.shipments ? this.$route.params.shipments : []"
            :lot-id="this.$route.params && this.$route.params.id ? this.$route.params.id : null"
            @on-close-dialog="handleCloseDialog('lots')">
          </component>
          <component v-if="dialog === 'BATCH_CSV_UPLOAD'" @on-close-dialog="dialog = false" :is="formComponents['BATCH_CSV_UPLOAD']"></component>
          <component v-if="dialog === 'CHANGE_PASSWORD'" @on-close-dialog="dialog = false" :is="formComponents['CHANGE_PASSWORD']"></component>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>

import CustomFabBtn from '@/components/CustomFabBtn'
import UserInfo from '@/components/UserInfo'

import BatchForm from '@/components/forms/BatchForm'
import BatchUploadCSV from '@/components/BatchUploadCSV'
import ChangePasswordForm from '@/components/forms/ChangePasswordForm'
import FarmForm from '@/components/forms/FarmForm'
import ShipmentForm from '@/components/forms/ShipmentForm'
import LotForm from '@/components/forms/LotForm'

import { canAccess } from '@/utils/permissions'
import { mapGetters } from 'vuex'

export default {
  name: 'Sidebar',
  props: {
    type: String
  },
  computed: mapGetters({
    profile: 'profile'
  }),
  data () {
    return {
      dialog: false,
      fabName: {
        'FARM': 'New Farm',
        'SHIPMENT': 'New Shipment',
        'LOT': 'New Lot',
        'BATCH': 'New Mixing Batch'
      },
      formComponents: {
        'BATCH': BatchForm,
        'FARM': FarmForm,
        'SHIPMENT': ShipmentForm,
        'LOT': LotForm,
        'BATCH_CSV_UPLOAD': BatchUploadCSV,
        'CHANGE_PASSWORD': ChangePasswordForm
      },
      formWidth: {
        'FARM': 630,
        'SHIPMENT': 360,
        'LOT': 650,
        'BATCH': 360,
        'BATCH_CSV_UPLOAD': 650,
        'CHANGE_PASSWORD': 360
      }
    }
  },
  components: {
    'custom-fab-btn': CustomFabBtn,
    'user-info': UserInfo
  },
  watch: {
    '$route.params' (newVal) {
      if (this.$route.name === 'farms.edit') {
        this.openDialog('FARM')
      }
      if (this.$route.name === 'lots.edit') {
        this.openDialog('LOT')
      }
      if (this.$route.name === 'shipments.edit') {
        this.openDialog('SHIPMENT')
      }
    }
  },
  methods: {
    canAccess,
    openDialog (type) {
      this.dialog = type
    },

    handleCloseDialog (route) {
      this.dialog = false
      this.$router.push({ name: route })
    },

    handleLogout () {
      this.$store.dispatch('logout')
    }
  },
  created () {
    if (this.$route.name === 'farms.edit' && canAccess('FARM_EDIT')) {
      this.openDialog('FARM')
    }
    if (this.$route.name === 'lots.edit' && canAccess('LOT_EDIT')) {
      this.openDialog('LOT')
    }
    if (this.$route.name === 'shipments.edit' && canAccess('SHIPMENT_EDIT')) {
      this.openDialog('SHIPMENT')
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar{
  width: 220px;
  background: #fafafa;
  // padding: 0 17px;
  position: relative;
  .fixed{
    position: fixed;
    top: 6%;
    bottom: 0;
    width: 220px;
    .footer{
      height: auto !important;
      font-size: 14px;
      background: none;
      .company{
        color: #1f5fac;
        font-style: italic;
        text-align: center;
        margin: 31px auto 29px;
      }
    }
  }
}
</style>
